var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Mail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22v33h51V22H12zm44 4L37.77 39.12 19.34 26H56zm-40 2.53L27.86 37 16 46.68V28.53zM17 51l14.23-11.62L37.78 44l6.53-4.69L58.54 51H17zm42-4.8l-11.32-9.27L59 28.81V46.2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Mail.2bb84c0c.svg";
export { SvgH1Mail as ReactComponent };